import { api } from './client';

/**
 * Get Book Ideas (#770 / #778). Propose only. Accept writes through book-board.
 */
export const seriesGetIdeasApi = {
  propose: (projectId, { sessionIds = [], batchIds = [] } = {}) => (
    api.post(`/projects/${projectId}/series-ideas/propose`, {
      session_ids: sessionIds,
      batch_ids: batchIds,
    })
  ),
  rememberEnding: (projectId, seriesEnding) => (
    api.post(`/projects/${projectId}/series-ideas/ending`, {
      series_ending: seriesEnding,
    })
  ),
  rememberShape: (projectId, endsOrContinues) => (
    api.post(`/projects/${projectId}/series-ideas/shape`, {
      ends_or_continues: endsOrContinues,
    })
  ),
};
